import React, { useState, useEffect } from 'react';
//Components
import ContainerFichaRota from './components/ContainerFichaRota';
import MainCard from '../../../components/MainCard/MainCard';
import NovaRota from './NovaRota';
import Loading from '../../../components/Loading/Loading';
//Api
import rotaColeta_api from '../../../api/rotaColeta_api';
//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';


export default function FichaRota({ id, btnVoltar, permissao }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado de controle da tela de edição de rota de coleta
    const [editar, setEditar] = useState(false);
    //Estado que guarda os dados da rota de coleta
    const [rota, setRota] = useState({});
    useEffect(() => {
        setLoading(true);
        rotaColeta_api.GetItem(id).then(response => {
            response.data.tbVeiculos_Id = response.data.tbVeiculos_Id.toString();
            response.data.tbDestinos_Id = response.data.tbDestinos_Id.toString();
            response.data.geradores = response.data.geradores.map(value => {
                value.cpfcnpj = mascaras.cpfcnpjMask(value.cpfcnpj);
                return value;
            })
            setRota(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);

    //Controle de exibição da tela de editar rota de coleta
    if (editar) {
        return <NovaRota permissao={permissao} rota={rota} btnVoltar={btnVoltar} />
    }

    return (
        <MainCard btnVoltar={btnVoltar} btnEditar={permissao === "Editar" ? () => setEditar(true) : null} >
            {loading
                ?
                <Loading />
                :
                <ContainerFichaRota rotaColeta={{ ...rota }} />
            }
        </ MainCard >
    )
}